import React, { memo } from 'react';
import LineInTimeline from './LineInTimeline';
import LineInTimelineOnEdit from './LineInTimelineOnEdit';

function compare(prevProps, currentProps) {
  if (prevProps.line.id !== currentProps.line.id) {
    return false;
  }
  if (prevProps.line.row !== currentProps.line.row) {
    return false;
  }
  if (prevProps.line.edit || currentProps.line.edit) {
    return false;
  }
  if (prevProps.line.status !== currentProps.line.status) {
    return false;
  }
  if (prevProps.timelineInfo.start !== currentProps.timelineInfo.start) {
    return false;
  }
  return true;
}

function LineInTimelineContainer({
  line,
  lineNum,
  firstLine,
  handleLineSubmit,
  addOrDeleteError,
  firstProduct,
  timelineInfo,
}: any) {
  const LineInTimelineComponent =
    line.edit || line.editActiveLine ? LineInTimelineOnEdit : LineInTimeline;
  return (
    <LineInTimelineComponent
      line={line}
      firstLine={firstLine}
      handleLineSubmit={handleLineSubmit}
      addOrDeleteError={addOrDeleteError}
      firstProduct={firstProduct}
      timelineInfo={timelineInfo}
    />
  );
}

export default memo(LineInTimelineContainer, compare);
